import 'core-js/stable'
import 'regenerator-runtime/runtime'
import './things-scene-components.import'
